import React, { useEffect, useState } from 'react';
import TimeDisplay from './TimeDisplay';

const ProductTimer = ({ initialTime, timerType }) => {
  const [remainingTime, setRemainingTime] = useState(initialTime);

  useEffect(() => {
    if (remainingTime <= 0) {
      setRemainingTime(0);
      return;
    }

    const interval = setInterval(() => {
      setRemainingTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [remainingTime]);

  const [days, hours, minutes, seconds] = getReturnValues(remainingTime);

  return (
    <>
      {remainingTime >= 0 && (
        <div className="flex text-light-blue justify-center  items-center">
          <ShowCounter
            days={days}
            hours={hours}
            minutes={minutes}
            seconds={seconds}
            timerType={timerType}
          />
        </div>
      )}
    </>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="show-counter flex flex-row-reverse justify-center items-center">
      <TimeDisplay value={formatWithLeadingZeros(days)} type={'روز'} />
      <p className="text-4xl text-primary-50 px-0.5 leading-none ">:</p>
      <TimeDisplay value={formatWithLeadingZeros(hours)} type={'ساعت'} />
      <p className="text-4xl text-primary-50 px-0.5 leading-none">:</p>
      <TimeDisplay value={formatWithLeadingZeros(minutes)} type={'دقیقه'} />
      <p className="text-4xl text-primary-50 px-0.5 leading-none">:</p>
      <TimeDisplay value={formatWithLeadingZeros(seconds)} type={'ثانیه'} />
    </div>
  );
};

const getReturnValues = (countDown) => {
  const days = Math.floor(countDown / (60 * 60 * 24));
  const hours = Math.floor((countDown % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((countDown % (60 * 60)) / 60);
  const seconds = Math.floor(countDown % 60);

  return [days, hours, minutes, seconds];
};

const formatWithLeadingZeros = (value) => {
  return value < 10 ? `0${value}` : value;
};

export default ProductTimer;
